import { Component, Input, OnDestroy, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'custom-textarea-accesor',
  templateUrl: './custom-textarea-accesor.component.html',
  styleUrls: ['./custom-textarea-accesor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomTextareaAccesorComponent),
      multi: true
    }
  ]
})
export class CustomTextareaAccesorComponent implements  ControlValueAccessor, OnDestroy {

  @Input() placeholder!: string;
  value = new FormControl(['', [], []]);
  subscriptions: Subscription[] = [];
  @Input() form?: FormGroup;
  @Input() inputName?: string;
  @Input() rows?: number = 4;

  writeValue(input: any): void {
    this.value.setValue(input);
  }
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

  isValidField(){
    return utils.isValidFieldForm(this.form!, this.inputName!)
  }
  errorField(){
    return utils.getFieldErrorForm(this.form!, this.inputName!)
  }
}

